import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { Store } from '@ngrx/store';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { PSTWEB_LIST_VALUE } from '@src/suite/common/enums/constants';
import { selectTranslatedKey } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { AppService } from '@suite/app.service';
import { LanguageSettings } from '@suite/common/services/language-settings';

@Component({
    selector: 'st-icon',
    templateUrl: './icon.html',
    styleUrls: ['./icon.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-icon',
    },
})
export class IconComponent extends EnpsComponent {
    store = inject(Store);
    data = input<StorytellingAssignmentRecord>();
    hasBorder = input(false, { transform: coerceBooleanProperty });
    type = input('');

    selectTranslatedKey = this.store.selectSignal(selectTranslatedKey);

    protected pstFieldName = PSTFieldNames.DescriptionType;

    public title = computed(() => {
        let title = this.store.selectSignal(selectTranslatedKey(`${PSTWEB_LIST_VALUE}_${this.pstFieldName}_${this.calculatedType()}`))();
        if (title) {
            return title;
        }
        title = this.type().toLowerCase();
        return title.charAt(0).toUpperCase() + title.slice(1);
    });

    hasValue = computed(() => {
        return !!this.data()?.PSTAssignmentOwner?.length;
    });

    calculatedType = computed(() => {
        return this.data()?.PSTCoverageType || this.type();
    });

    constructor(
        public appService: AppService,
        protected languageSettings: LanguageSettings
    ) {
        super();
    }
}
